import { GetBrandsLogosByMerchantResponse } from "@kushki/js/lib/types/get_brands_logos_by_merchant_response";
import { ImgBrandEnum } from "containers/Card/store/ImgBrandEnum";
import { PciImages } from "root/shared/PciImages";
import { ITransferAmount } from "types/transfer_amount";
import { CurrencySymbols } from "./CurrencyEnum";
/**
 * Utility Functions
 */
const MILLENNIUM: number = 2000;
const DATE_SEPARATOR: string = "/";

function checkValidity(
  value: string,
  rules: {
    required: boolean;
    isDate?: boolean;
    isEmail?: object;
    isCardNumber?: boolean;
    minLength?: number;
  }
): boolean {
  let isValid: boolean = true;

  if (rules.required) isValid = isValid && value.trim() !== "";

  if (rules.minLength !== undefined && value.trim() !== "")
    isValid = isValid && value.length >= rules.minLength;

  if (rules.isCardNumber !== undefined && value.trim() !== "")
    isValid = isValid && validateCard(value);

  if (rules.isDate !== undefined && value.trim() !== "") {
    const arr: string[] = value.split(DATE_SEPARATOR);
    const [month, year] = arr;

    isValid =
      isValid &&
      new Date(parseInt(year, 10) + MILLENNIUM, parseInt(month, 10)) >=
        new Date();
  }

  if (rules.isEmail !== undefined && value.trim() !== "") {
    const emailPattern: RegExp = /\S+@\S+\.\S+/;

    /* tslint:disable:all */
    isValid = isValid && emailPattern.test(value);
  }

  return isValid;
}

function validateCard(value: string): boolean {
  let validCard: boolean;
  const cardValue: string = value.replace(/\D/g, "");

  validCard = cardValue.length > 6;

  return validCard;
}

function calculateTotalAmount(amount: ITransferAmount): number {
  let total: number = amount.iva + amount.subtotalIva + amount.subtotalIva0;

  if (amount.extraTaxes !== undefined) {
    total +=
      amount.extraTaxes.agenciaDeViajes !== undefined
        ? amount.extraTaxes.agenciaDeViajes
        : 0;
    total += amount.extraTaxes.iac !== undefined ? amount.extraTaxes.iac : 0;
    total +=
      amount.extraTaxes.propina !== undefined ? amount.extraTaxes.propina : 0;
    total +=
      amount.extraTaxes.tasaAeroportuaria !== undefined
        ? amount.extraTaxes.tasaAeroportuaria
        : 0;
  }
  total = Number.parseFloat(total.toFixed(2));

  return total;
}

function getTransferImage(transferType: string): PciImages {
  switch (transferType) {
    case "Mexico":
      return PciImages.stpImage;
    case "Chile":
      return PciImages.none;
    case "Colombia":
      return PciImages.pseTransferImage;
    default:
      return PciImages.none;
  }
}

function getCashImage(currency: string): PciImages {
  switch (currency) {
    case "MXN":
    case "USD":
    case "COP":
    case "BRL":
    default:
      return PciImages.none;
  }
}

function getCashOutImage(currency: string): PciImages {
  switch (currency) {
    case "COP":
      return PciImages.pciPuntoRed;
    default:
      return PciImages.none;
  }
}

function getTransferIcon(currency: string): string {
  switch (currency) {
    case "CLP":
      return "transferChile";
    case "MXN":
      return "transferMexico";
    case "COP":
      return "transfer";
    default:
      return "";
  }
}

function getCashIcon(currency: string): string {
  switch (currency) {
    case "USD":
      return "cashFacilito";
    case "MXN":
      return "cashRedEfectiva";
    case "COP":
      return "cashBancoBogota";
    default:
      return "";
  }
}

function getCurrencySymbol(currency: string | undefined): string {
  return CurrencySymbols[`${currency}`] || "";
}
function removeWhitespaceAndTransformToLowerCase(param: string): string {
  return param.toLowerCase().replace(/\s/g, "");
}

function getUrlIconBrand(
  nameBrand: string,
  listBrandsLogosMerchant: GetBrandsLogosByMerchantResponse[]
): string {
  const cardFound:
    | GetBrandsLogosByMerchantResponse
    | undefined = listBrandsLogosMerchant.find(
    (card: GetBrandsLogosByMerchantResponse) =>
      removeWhitespaceAndTransformToLowerCase(card.brand) ===
      removeWhitespaceAndTransformToLowerCase(nameBrand)
  );

  if (cardFound !== undefined) return cardFound.url;

  const imgCardEnumFound: string | undefined = Object.keys(ImgBrandEnum).find(
    (imgBrand: string) =>
      removeWhitespaceAndTransformToLowerCase(imgBrand) ===
      removeWhitespaceAndTransformToLowerCase(nameBrand)
  );

  if (imgCardEnumFound !== undefined) return ImgBrandEnum[imgCardEnumFound];

  return "";
}

export {
  checkValidity,
  calculateTotalAmount,
  getTransferImage,
  getCashImage,
  getTransferIcon,
  getCashIcon,
  getCurrencySymbol,
  getCashOutImage,
  removeWhitespaceAndTransformToLowerCase,
  getUrlIconBrand,
};



// WEBPACK FOOTER //
// ./src/shared/Utility.tsx